import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationStart,
  Router,
  RouterModule,
  RouterOutlet,
} from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faAndroid, faApple } from '@fortawesome/free-brands-svg-icons';
import {
  faCalendarDays,
  faCommentDots,
} from '@fortawesome/free-regular-svg-icons';
import {
  faSearch,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';
import {
  faAngleDown,
  faArrowRight,
  faDownload,
  faGear,
  faHeadset,
  faHome,
  faSignOut,
  faUsers,
  faBars,
  faWallet,
} from '@fortawesome/free-solid-svg-icons';
import { Store } from '@ngrx/store';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { Subject, debounceTime, distinctUntilChanged, filter, takeUntil } from 'rxjs';
import { AccountType_v2 } from '../../models/app-enums';
import { selectUser } from '../../ngrx/data.reducer';
import { HelperService, whiteLogo } from '../../services/helper.service';
import { ResizeService } from '../../services/resize.service';
import { RedirectAppComponent } from '../redirect-app/redirect-app.component';
import { SearchSuggestionsComponent } from '../search-suggestions/search-suggestions.component';
import { FormsModule } from '@angular/forms';
import { AddCreatorInfoComponent } from '../add-creator-info/add-creator-info.component';
import { ModalService } from '../../services/modal.service';
@Component({
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    FontAwesomeModule,
    LazyLoadImageModule,
    RouterModule,
    RedirectAppComponent,
    SearchSuggestionsComponent,
    FormsModule,
    AddCreatorInfoComponent,
  ],
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() set scrollData(data: any) {
    if (data) {
      this.scrollling(data);
    }
  }
  public routeName: string = this.router.url;
  PAYMENT_ROUTE = '/payment'
  IsComeJoinUs: boolean = false;
  showIcon: boolean = false;
  userAccountTypes = AccountType_v2;
  ButtonLoader: boolean = false;
  isAppleBtn: boolean = false;
  isAndriodBtn: boolean = false;
  userDetails: any;
  scrollTop: number = 0;
  scrollUp: boolean = false;
  faArrowRight = faArrowRight;
  faAngleDown = faAngleDown;
  faComment = faCommentDots;
  faWallet = faWallet;
  faUsers = faHeadset;
  faCalendar = faCalendarDays;
  faGear = faGear;
  faHome = faHome;
  faSignOut = faSignOut;
  faApple = faApple;
  faAndroid = faAndroid;
  fabar = faBars;
  faInstall = faDownload;
  user$ = this.store.select(selectUser);
  logo: string = whiteLogo;
  scrollLogo: string = whiteLogo;
  headerBgColor: string = '#fff';
  headerScrollColor: string = '#fff';
  btn: string = '#fff';
  btnScroll: string = '#fff';
  color: string = '#fff';
  scrollColor: string = '#fff';
  smallScrollLogo: string = whiteLogo;
  smallLogo: string = whiteLogo;
  iconColor: string = '#fff';
  scrollIconColor: string = '#fff';
  referralCode = localStorage.getItem('referralCode') || null;
  show: boolean = false;
  deferredPrompt: any;
  showInstallButton = false;
  isMobileMenuOpen = false;

  // search creators props
  search!: string;
  faSearch = faSearch;
  faTimes = faTimesCircle;
  mentorSearchQuery: string = null;
  mentorSearchQueryUpdate = new Subject<any>();
  searchValue: any = null;
  inputActive: boolean = false;
  inputActiveMobile: boolean = false;
  showSearch: boolean = false;
  @ViewChild('suggestions', { static: false }) suggestions: ElementRef;

  @HostListener('window:beforeinstallprompt', ['$event'])
  onBeforeInstallPrompt(event: Event) {
    event.preventDefault();
    this.deferredPrompt = event;
    this.showInstallButton = true;
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const target = event.target as HTMLElement;

    if (
      !target.closest('.custom-mobile-menu') &&
      !target.closest('.mobile-menu-toggle')
    ) {
      this.isMobileMenuOpen = false;
    }

    if (!target.closest('.topBtn')) {
      this.show = false;
    }

    if (!target.closest('.search')) {
      this.inputActive = false;
      this.showSearch = false;
    }

    if (!target.closest('.searchBtnMobile')) {
      if (!target.closest('.search-mobile')) {
        this.inputActiveMobile = false;
        this.showSearch = false;
      }
    }

    const clickedInside = this.suggestions?.nativeElement.contains(
      event.target,
    );
    if (!clickedInside) {
      this.reset();
    }

  }


  private destroy$ = new Subject<void>();
  constructor(
    public router: Router,
    private store: Store,
    public resize: ResizeService,
    private activatedRoute: ActivatedRoute,
    public helper: HelperService,
    private modalService: ModalService,
  ) {
    if (this.routeName === this.PAYMENT_ROUTE) {
      localStorage.setItem('backNavigationUrl', this.PAYMENT_ROUTE);
    }
    this.modalService
      .getModalStateObservable()
      .pipe(
        takeUntil(this.destroy$),
        distinctUntilChanged(
          (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr),
        ),
      )
      .subscribe((state: any) => {
        this[state?.id] = state?.show;
      });

    this.user$
      .pipe(
        takeUntil(this.destroy$),
        distinctUntilChanged(
          (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr),
        ),
      )
      .subscribe((user) => {
        if (
          user &&
          (user?.userType?.toLowerCase() == 'fan' ||
            user?.userType?.toLowerCase() == 'creator' ||
            user?.userType?.toLowerCase() == 'both')
        ) {
          this.userDetails = user;
          // console.log('userDetails', this.userDetails);

        } else {
          this.userDetails = null;
        }
      });
    this.router.events
      .pipe(
        takeUntil(this.destroy$),
        filter((event) => event instanceof NavigationStart),
        distinctUntilChanged(
          (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr),
        ),
      )
      .subscribe(() => {
        this.updateHeaderState(this.activatedRoute.root);
      });
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.destroy$),
        distinctUntilChanged(
          (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr),
        ),
      )
      .subscribe((event) => {
        this.updateHeaderState(this.activatedRoute.root);
      });
    this.isAppleBtn = this.isAppleDevice();
    this.isAndriodBtn = this.isAndroidDevice();

    // search

    this.mentorSearchQueryUpdate
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        takeUntil(this.destroy$),
        distinctUntilChanged(
          (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr),
        ),
      )
      .subscribe((value) => this.handleMentorSearchQuery(value));
  }

  ngOnInit(): void {
    this.updateHeaderState(this.activatedRoute.root);
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  onInstall() {
    if (this.deferredPrompt) {
      this.deferredPrompt.prompt();
      this.deferredPrompt.userChoice.then((choiceResult: any) => {
        if (choiceResult.outcome === 'accepted') {
          // console.log('User accepted the A2HS prompt');
        } else {
          // console.log('User dismissed the A2HS prompt');
        }
      });
    }
  }
  scrollling(scroll) {
    this.scrollTop = scroll?.scrollPosition;
    this.scrollUp = scroll?.scrollUp;
  }
  togglePassword() {
    const passEl = document.querySelector('#exampleInputPassword1');
    const eyeIcon = document.querySelector('.password-eye .fa');
    const type =
      passEl.getAttribute('type') === 'password' ? 'text' : 'password';
    passEl.setAttribute('type', type);
    eyeIcon?.classList?.toggle('fa-eye-slash');
    eyeIcon?.classList?.toggle('fa-eye');
  }
  isAppleDevice(): boolean {
    const userAgent =
      navigator.userAgent || navigator.vendor || (window as any).opera;
    return /iPhone|iPod|iPad/i.test(userAgent);
  }

  isAndroidDevice(): boolean {
    const userAgent =
      navigator.userAgent || navigator.vendor || (window as any).opera;
    return /Android/i.test(userAgent);
  }
  private updateHeaderState(route: any): void {
    while (route.firstChild) {
      route = route.firstChild;
    }
    const data = route.snapshot.data;
    if (data && Object.keys(data).length !== 0) {
      this.headerBgColor = data.bg || '#fff';
      this.headerScrollColor = data.scrollBg || '#fff';
      this.btn = data.btn || '#fff';
      this.btnScroll = data.btnScroll || '#fff';
      this.color = data.color || '#fff';
      this.scrollColor = data.scrollColor || '#fff';
      this.iconColor = data.iconColor || '#fff';
      this.scrollIconColor = data.scrollIconColor || '#fff';
      this.logo = data.logo || whiteLogo;
      this.scrollLogo = data.scrollLogo || whiteLogo;
      this.smallLogo = data.smallLogo || whiteLogo;
      this.smallScrollLogo = data.smallScrollLogo || whiteLogo;
      this.IsComeJoinUs = data.joinNow || false;
      this.showIcon = data.showIcon || false;
    }
  }

  // search
  reset() {
    this.mentorSearchQuery = null;
    this.searchValue = null;
  }

  private handleMentorSearchQuery(value: string): void {
    if (value.trim() === '') {
      this.showSearch = false;
      this.searchValue = null;
    } else {
      this.searchValue = value;
      this.showSearch = true;
    }
  }

  toggleSearch() {
    this.inputActive = !this.inputActive;
  }

  toggleSearchMobile() {
    this.inputActiveMobile = !this.inputActiveMobile;
  }

  navigateToLoginScreen() {
    if (this.router.url === this.PAYMENT_ROUTE) {
      localStorage.setItem('backNavigationUrl', this.PAYMENT_ROUTE);
    }
    this.router.navigate(['/signin']);
  }
}
